import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import IndivisualQuantity from "../../utils/IndivisualQuantity";
import MenuCard from "../Menu/MenuCard";
// import Konsole from "../../utils/konsole/Konsole";
import { useTranslation } from "react-i18next";
const FeaturedItems = () => {
  const storeData = useSelector((state: any) => state?.store);
  const { items } = useSelector((state: any) => state?.cartData);
  const {t} = useTranslation()

  // Konsole.log("storeData",itemCount, storeData);

  // @@ slider screen view
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.75,
          slidesToScroll: 2,
        },
      },
       {
        breakpoint: 650,
        settings: {
          slidesToShow: 2.75,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.75,
          slidesToScroll: 2,
        },
      },
       {
        breakpoint: 400,
        settings: {
          slidesToShow: 2.55,
          slidesToScroll: 2,
        },
      },
       {
        breakpoint: 350,
        settings: {
          slidesToShow: 2.15,
          slidesToScroll: 2,
        },
      },
    ],
  };

  //  return all category
  const allFeaturedItem = useMemo(() => {
    return storeData?.allFeaturedItem || [];
  }, [storeData]);



  // Konsole.log("allFeaturedItem", allFeaturedItem);
  return (
    <>
      {allFeaturedItem?.length > 0 ? (
        <div className="mb-6 w-full overflow-hidden">
          <h3 className="section-title md:mb-3 mb-4">{t("Home.featuredItems")}</h3>          
          <div className="w-full flex justify-center featured-slide-mobile"> 
          <div className="slider-container w-full max-w-9xl text-center">
            <Slider {...settings}>
              {allFeaturedItem.map((sub: any) => {
                return sub?.sub_category_data?.length > 0
                  ? sub?.sub_category_data?.map((sub_cat: any) => {
                      return sub_cat?.item_data?.length > 0
                        ? sub_cat?.item_data?.map(
                            (feItem: any, feIndex: number) => {
                              return (
                                <>
                                  <MenuCard
                                    refrencePage="FeaturedItem"
                                    key={feItem?.item_id + feIndex}
                                    classNameType={feItem?.item_type == 0 ? "Veg" : "nonVeg"}
                                    item={feItem}
                                    quantity={IndivisualQuantity(items,feItem.item_id) || 0}
                                    menu_id={sub_cat.menu_id}
                                    taxdata={sub_cat}
                                  />
                                </>
                              );
                            }
                          )
                        : null;
                    })
                  : null;
              })}
            </Slider>
          </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default FeaturedItems;
